import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaChartPie, FaFilter } from 'react-icons/fa';
import { Button, PageHeader } from 'components/common';

const LeadHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-bg-white tw-rounded tw-border tw-border-solid tw-border-slate-200 tw-shadow-sm tw-mb-3 tw-px-4 tw-py-3">
      <PageHeader
        variant="plain"
        title="Leads"
        icon={FaFilter}
        onBack={() => navigate(-1)}
        actions={
          <>
            <Button variant="primary" size="sm" leftIcon={FaPlus} onClick={() => navigate('/crm/leads/new')}>
              <span className="tw-hidden xl:tw-inline">New Lead</span>
            </Button>
            <Button variant="primary" size="sm" leftIcon={FaChartPie} onClick={() => navigate('/crm/leads/dashboard')}>
              <span className="tw-hidden xl:tw-inline">Dashboard</span>
            </Button>
          </>
        }
      />
    </div>
  );
};

export default LeadHeader;
